var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('origin-groups-form',{attrs:{"origin-id":_vm.origingroupId,"distribution-id":_vm.distributionId,"details":""},on:{"submit":_vm.editErrorPage,"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }